<template>
  <div class="video-pane">
    <!-- eslint-disable-next-line -->
    <video
      ref="player"
      class="element-video"
      :poster="poster"
      :src="videoUrl"
      :controls="playing"
      @error="onError"
      @play="onPlay"
      @pause="onPause"></video>
    <div :class="['play-btn', { 'hidden': (useFallback || playing) }]">
      <span class="action-btn ico-play-video" @click="playVideo"></span>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'video-component',
    props: {
      videoUrl: {
        type: String,
        required: false,
        default: '',
      },
      poster: {
        type: String,
        required: false,
        default: '',
      },
      title: {
        type: String,
        required: false,
        default: '',
      },
    },
    data() {
      return {
        playing: false,
        useFallback: false,
      };
    },
    methods: {
      playVideo() {
        this.$refs.player.play();
      },
      pauseVideo() {
        this.$refs.player.pause();
      },
      onPlay() {
        this.playing = true;
      },
      onPause() {
        this.playing = false;
      },
      onError({ target: { error } }) {
        if (error && error.code) {
          this.useFallback = true;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .video-pane {
    position: relative;
    height: 100%;
    width: 100%;

    & > video {
      height:100%;
      width:100%;

      &[poster] {
        object-fit: cover;
        object-position: right;
      }
    }

    .play-btn {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 1;
      cursor: pointer;
      height: 64px;
      width: 64px;
      @media (max-width: 1024px) {
        height: 40px;
        width: 40px
      }

      &.hidden {
        display: none;
      }
    }
  }
</style>
